import { CommonModule } from '@angular/common';
import { Component, NgModule, ChangeDetectionStrategy } from '@angular/core';
import { DxButtonModule } from 'devextreme-angular/ui/button';

@Component({
    selector: 'portal-shortcut',
    templateUrl: './portal-shortcut.component.html',
    styleUrls: ['./portal-shortcut.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PortalShortCutComponent {
  constructor() {}

  onButtonClick() {
    //open new tab with url of Patricia
    window.open('https://portal.calysta.eu/home', '_blank');
  }
}

@NgModule({
  imports: [CommonModule, DxButtonModule],
  declarations: [PortalShortCutComponent],
  exports: [PortalShortCutComponent],
})
export class PortalShortcutModule {}
